/**
 * Labstep
 *
 * @module components/ProtocolValue/Form/Create
 * @desc Form to create protocol value
 */

import { FormCreateContainer } from 'labstep-web/core/Form/Create';
import { useActiveGroup } from 'labstep-web/hooks/activeGroup';
import { ProtocolValue } from 'labstep-web/models/protocol-value.model';
import type React from 'react';
import { useState } from 'react';
import { getProtocolValueFormFields } from '../fields';
import { preSubmit } from '../preSubmit';
import type { ProtocolValueFormCreateProps } from './types';

export const ProtocolValueFormCreate: React.FC<
  ProtocolValueFormCreateProps
> = ({
  entityName,
  experiment,
  isInput,
  body = {},
  onSubmit,
  defaultValues,
  ...rest
}) => {
  const { activeGroup } = useActiveGroup();
  const [resourceCategoryId, setResourceCategory] = useState<
    string | null
  >(null);

  const [fields, setFields] = useState(
    getProtocolValueFormFields({
      resourceCategoryId,
    }),
  );

  const props = {
    body: {
      ...body,
      is_input: isInput,
      is_output: !isInput,
      is_lineage: true,
      is_variable: true,
      group_id: activeGroup!.guid,
    },
    autoFocus: true,
    entityName: ProtocolValue.entityName,
    preSubmit,
    onFormChange: (values: any): void => {
      if (resourceCategoryId !== values.resource_template_id) {
        setResourceCategory(values.resource_template_id);
        setFields(
          getProtocolValueFormFields({
            ...(values.resource_template_id && {
              resourceCategoryId: values.resource_template_id,
            }),
          }),
        );
      }
    },
    defaultValues,
    fields: fields,
    ...rest,
  };

  return (
    <FormCreateContainer
      {...props}
      parentId={experiment.idAttr}
      parentName={experiment.entityName}
    />
  );
};
